var map = {
	"./p1.jpg": 615,
	"./p2.jpg": 616,
	"./p3.jpg": 617,
	"./p4.jpg": 618,
	"./v1.jpg": 619,
	"./v2.jpg": 620,
	"./v3.jpg": 621,
	"./v4.jpg": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;